import { Button, Dropdown, Form, Modal, Table } from "react-bootstrap";
import { WhatsappModal } from "../campaigningComponents/WhatsappModal"
import { useEffect, useMemo, useState } from "react";
import {
  DeleteRequest,
  GetRequest,
  PutRequest,
} from "../../Utils/hooks/ApiHandler";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faEllipsisVertical,
  faEye,
  faTrash,
  faLayerGroup,
} from "@fortawesome/free-solid-svg-icons";
import DeleteModal from "../DeleteModal";
import { toast } from "sonner";
import {
  getAllCities,
  getAllStates,
  getCountries,
} from "../../Utils/hooks/location";
import useCommonData from "../../Utils/actions/advanceFilteringAction";
import { Filter } from "../../CommonComponents/Filter";
import { AuthorizationCard } from "../../CommonComponents/AuthorizationCard";
import { customStyles, fetchTemporaryFilterData } from "../../Utils/helpers/commonhelper";
import { useGlobalState } from "../../Utils/hooks/useFilterQueryValue";
import Select from "react-select";
import { Pagination } from "../../CommonComponents/Pagination";

const WHATSAPP_CAMPAIGN_FILTER_QUERY_KEY = "whatsappCampaignApplyFilterQueryValues";
const WHATSAPP_CAMPAIGN_FILTER_PARAMS_KEY = "whatsappCampaignFilterDataParams";
const FILTER_CARD_LIMIT = 15;
const LIST_LIMIT_OPTIONS = [25, 100, 200, 300];

const industryOptions = [
  { value: "Technology", label: "Technology" },
  { value: "Healthcare", label: "Healthcare" },
  { value: "Finance", label: "Finance" },
  { value: "Education", label: "Education" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Retail", label: "Retail" },
  { value: "Real Estate", label: "Real Estate" },
  { value: "Construction", label: "Construction" },
  { value: "Transportation", label: "Transportation" },
  { value: "Food & Beverage", label: "Food & Beverage" },
  { value: "Entertainment", label: "Entertainment" },
  { value: "Consulting", label: "Consulting" },
  { value: "Marketing & Advertising", label: "Marketing & Advertising" },
  { value: "Legal Services", label: "Legal Services" },
  { value: "Insurance", label: "Insurance" },
  { value: "Telecommunications", label: "Telecommunications" },
  { value: "Energy", label: "Energy" },
  { value: "Agriculture", label: "Agriculture" },
  { value: "Automotive", label: "Automotive" },
  { value: "Aerospace", label: "Aerospace" },
  { value: "Pharmaceuticals", label: "Pharmaceuticals" },
  { value: "Banking", label: "Banking" },
  { value: "E-commerce", label: "E-commerce" },
  { value: "Media", label: "Media" },
  { value: "Non-profit", label: "Non-profit" },
  { value: "Government", label: "Government" },
  { value: "Hospitality", label: "Hospitality" },
  { value: "Travel & Tourism", label: "Travel & Tourism" },
  { value: "Sports & Recreation", label: "Sports & Recreation" },
  { value: "Beauty & Wellness", label: "Beauty & Wellness" },
];

const businessTypeOptions = [
  { value: "Sole Proprietorship", label: "Sole Proprietorship" },
  { value: "Limited Liability Partnership(LLP)", label: "Limited Liability Partnership(LLP)" },
  { value: "Private Limited Company", label: "Private Limited Company" },
  { value: "Public Limited Company", label: "Public Limited Company" },
];

const employeeSizeOptions = [
  { value: '1-10', label: '1-10' },
  { value: '11-50', label: '11-50' },
  { value: '51-200', label: '51-200' },
  { value: '201-500', label: '201-500' },
  { value: '501-1000', label: '501-1000' },
  { value: '1001+', label: '1001+' }
];

export const WhatsAppCampainging = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [campaignName, setCampaignName] = useState("");
  const [updateCampaignId, setUpdateCampaignId] = useState(null);
  const [description, setDescription] = useState("");
  const [selectedTab, setSelectedTab] = useState("leads");
  const [listTableData, setListTableData] = useState([]);
  const [tabData, setTabData] = useState([]);
  // state for selecting filterquery without clicking on card
  const [filterQueryValues, setFilterQueryValues] = useState([]);
  //refetch tab data
  const [refetchTabData, setRefetchTabData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeCardId, setActiveCardId] = useState(null);
  const [filterCardOffset, setFilterCardOffset] = useState(0);
  const [filterPageCount, setFilterPageCount] = useState(0);
  const [listLimit, setListLimit] = useState(25);
  const [listTotalCount, setListTotalCount] = useState(0);
  const [listLoading, setListLoading] = useState(false);
  const navigate = useNavigate();
  const [customer, setCustomer] = useLocalStorageState("customer");

  // rbac permission object  
  const [PERMISSION, _] = useLocalStorageState("permission");

  const customerId = customer?.customer_details?.customer_id;
  const loginUserId = customer?.customer_details?.id;
  const userType = customer?.customer_details?.user_type;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;

  const getApplyFilterModuleName = (tab) => {
    if (tab === "leads") return "lead";
    if (tab === "contact") return "contacts";
    if (tab === "company") return "company";
    return "lead";
  };

  const getFilterCardsEndpoint = (tab) => {
    const qs = `?offset=${filterCardOffset}&limit=${FILTER_CARD_LIMIT}&search=`;
    if (tab === "leads") {
      return `common/fetchFilterCard/${customerId}/leads/${loginUserId}${qs}`;
    }
    if (tab === "contact") {
      return `contacts/fetchFilterCards/${customerId}/${loginUserId}${qs}`;
    }
    if (tab === "company") {
      return `company/fetchFilterCards/${customerId}/${loginUserId}${qs}`;
    }
    return "";
  };

  const getFilterRenameModuleName = (tab) => {
    if (tab === "leads") return "leads";
    if (tab === "contact") return "contact";
    if (tab === "company") return "company";
    return "leads";
  };

  const getDeleteFilterEndpoint = (tab, filterId) => {
    if (tab === "leads") return `common/deleteFilter/${filterId}`;
    if (tab === "contact") return `contacts/deleteFilter/${filterId}`;
    if (tab === "company") return `company/deleteFilter/${filterId}`;
    return "";
  };
  const headers = {
    authentication: rf,
    Authorization: token,
  };
  const extras = { customer, setCustomer, rf, navigate };

  // parse values for filter query
  const [filterQueryValue, setFilterQueryValue] = useState([]);
  //parse data state for filter
  const [parsedFilterData, setParsedFilterData] = useState(null);
  // state for filter dropdown contacts
  const [filterDropdown, setFilterDropdown] = useState(false);
  // states to store the filter data
  const [filterStates, setFilterState] = useState([]);
  // filter state to see the temoporary applied filter data,
  const [tempFilterData, setTempFilterData] = useState(null);
  const [tempFilterDataLoading, setTempFilterDataLoading] = useState(false);
  const [listOffset, setListOffset] = useState(0);
  const [whatsappCampaignFilterDataParams, setWhatsappCampaignFilterDataParams] = useGlobalState(
    WHATSAPP_CAMPAIGN_FILTER_PARAMS_KEY,
    { currAdvFilter: null, applyFilterData: {} }
  );
  const [currAdvFilter, setCurrAdvFilter] = useState(
    whatsappCampaignFilterDataParams?.currAdvFilter || null
  );
  const [whatsappCampaignFilterValues] = useGlobalState(
    WHATSAPP_CAMPAIGN_FILTER_QUERY_KEY,
    {}
  );
  // country state
  const [country, setCountries] = useState([]);
  // all states for filter field hydration
  const [allState, setAllState] = useState([]);
  // all cities for filter field hydration
  const [allCity, setAllCity] = useState([]);
  // loading state for delete
  const [isLoading, setIsLoading] = useState(false)

  // whatsapp campaign permission grant
  const whatsappCampaignGrant = PERMISSION.campaigning.whatsapp_campaign;
  const [pipeline, setPipelines] = useState(null)
  const [pipelineStages, setPipelineStages] = useState(null)
  const [selectedPipelineId, setSelectedPipelineId] = useState(null)

  // common advance filter api calls that will be needed everywhere
  const { leadOwner, lead_source, company } = useCommonData({
    leadOwner: true,
    leadSource: true,
    companies: true,
    contacts: false,
  });

  // by default since leads is the very first module we have make sure that all the endpoints and apply query stay with respective to lead.
  const [currModule, setCurrModule] = useState("leads");
  const [currFilterEndpoint, setCurrFilterEndpoint] = useState("common/filterQuery");
  const [currFilterApplyQuery, setCurrFilterApplyQuery] = useState("lead/applyFilter");


  const isApplyFilterActive =
    currAdvFilter === "apply" &&
    whatsappCampaignFilterValues?.filter_values?.length > 0;

  const dataToDisplay = isApplyFilterActive
    ? tempFilterData?.data || []
    : listTableData;

  const activeListTotalCount = isApplyFilterActive
    ? tempFilterData?.total_count ?? 0
    : listTotalCount;

  const startItemIndex = activeListTotalCount > 0 ? listOffset + 1 : 0;
  const endItemIndex = Math.min(listOffset + listLimit, activeListTotalCount);
  const listPageCount = Math.max(1, Math.ceil(activeListTotalCount / listLimit) || 1);

  const pipelineOptions =
    pipeline !== null &&
    pipeline?.map((el) => ({
      value: el.id,
      label: el.pipeline_name,
    }));

  const applyFilterDataParams = {
    filterValues: whatsappCampaignFilterValues,
    selectedPipelineId,
    currView: "list",
    offset: listOffset,
    limit: listLimit,
    module_name: getApplyFilterModuleName(selectedTab),
    customerId,
    loginUserId,
    userType,
    headers,
    extras,
    setTempFilterData,
    setLoading: setTempFilterDataLoading,
    setFilterState,
    setFilterDropdown,
  };

  useEffect(() => {
    setWhatsappCampaignFilterDataParams({
      currAdvFilter,
      applyFilterData: {
        ...applyFilterDataParams,
        filterValues: whatsappCampaignFilterValues,
        selectedPipelineId,
        currView: "list",
        offset: listOffset,
        limit: listLimit,
        module_name: getApplyFilterModuleName(selectedTab),
      },
    });
  }, [
    currAdvFilter,
    whatsappCampaignFilterValues,
    listOffset,
    listLimit,
    selectedPipelineId,
    selectedTab,
  ]);

  useEffect(() => {
    if (selectedTab === "leads" && !selectedPipelineId) return;
    if (
      currAdvFilter === "apply" &&
      whatsappCampaignFilterValues?.filter_values?.length > 0
    ) {
      fetchTemporaryFilterData(whatsappCampaignFilterDataParams?.applyFilterData);
    }
  }, [whatsappCampaignFilterDataParams?.applyFilterData]);

  const dropdownOptions = useMemo(() => {
    if (selectedTab === "contact") {
      return [
        { value: "first_name", label: "First Name" },
        { value: "last_name", label: "Last Name" },
        { value: "email", label: "Email" },
        { value: "phone", label: "Phone" },
        { value: "owner_id", label: "Owner", option: leadOwner },
        { value: "report_to", label: "Report To" },
        { value: "visible_to", label: "Visible To", option: leadOwner },
        { value: "company_id", label: "Company Name", option: company },
        { value: "designation", label: "Designation" },
        { value: "department", label: "Department" },
        { value: "decision_maker", label: "Decision Maker" },
        { value: "city", label: "City", option: allCity },
        { value: "state", label: "State", option: allState },
        { value: "country", label: "Country", option: country },
        { value: "zipcode", label: "Zipcode" },
        { value: "lead_source_id", label: "Lead Source", option: lead_source },
        { value: "tag", label: "Tags" },
        { value: "note", label: "Notes" },
      ];
    }
    if (selectedTab === "company") {
      return [
        { value: "company_name", label: "Company Name" },
        { value: "website", label: "Website" },
        { value: "industry", label: "Industry", option: industryOptions },
        { value: "business_type", label: "Business Type", option: businessTypeOptions },
        { value: "employee_size", label: "Employee Size", option: employeeSizeOptions },
        { value: "owner_id", label: "Owner", option: leadOwner },
        { value: "email", label: "Email" },
        { value: "phone", label: "Phone" },
        { value: "address", label: "Address" },
        { value: "city", label: "City", option: allCity },
        { value: "state", label: "State", option: allState },
        { value: "country", label: "Country", option: country },
        { value: "zipcode", label: "Zipcode" },
        { value: "about", label: "About" },
        { value: "rating", label: "Rating" },
      ];
    }
    return [
      { value: "first_name", label: "First Name" },
      { value: "last_name", label: "Last Name" },
      { value: "email", label: "Email" },
      { value: "phone", label: "Phone" },
      { value: "owner_id", label: "Owner", option: leadOwner },
      { value: "company_id", label: "Company Name", option: company },
      { value: "designation", label: "Designation" },
      { value: "department", label: "Department" },
      { value: "city", label: "City", option: allCity },
      { value: "state", label: "State", option: allState },
      { value: "country", label: "Country", option: country },
      { value: "zipcode", label: "Zipcode" },
      { value: "lead_source_id", label: "Lead Source", option: lead_source },
      { value: "status", label: "Status" },
      { value: "priority", label: "Priority" },
      { value: "tag", label: "Tags" },
      { value: "note", label: "Notes" },
    ];
  }, [
    selectedTab,
    leadOwner,
    lead_source,
    company,
    country,
    allState,
    allCity,
  ]);

  // sub filter dropdown option
  const subFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "contains", label: "Contains" },
    { value: "not_contains", label: "Not-Contains" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
    { value: "is_empty", label: "Is Empty" },
    { value: "is_not_empty", label: "Is Not Empty" },
    { value: "begins_with", label: "Begins With" },
  ];

  const customSubFilter = [
    { value: "equals", label: "Equals" },
    { value: "not_equals", label: "Not-Equals" },
    { value: "is_set", label: "Is Set" },
    { value: "is_not_set", label: "Is Not Set" },
    { value: "in", label: "In" },
    { value: "not_in", label: "Not-In" },
  ];



  useEffect(() => {
    if (selectedTab === "leads") {
      setCurrModule("leads")
      setCurrFilterEndpoint("common/filterQuery")
      setCurrFilterApplyQuery("lead/applyFilter")
    } else if (selectedTab === "company") {
      setCurrFilterEndpoint("company/filterQuery")
      setCurrFilterApplyQuery("company/applyFilter")
      setCurrModule("company")
    } else if (selectedTab === "contact") {
      setCurrFilterEndpoint("contacts/filterQuery")
      setCurrFilterApplyQuery("contacts/applyFilter")
      setCurrModule("contacts")
    };
    setFilterCardOffset(0);
    setListOffset(0);
    setCurrAdvFilter(null);
    setTempFilterData(null);
  }, [selectedTab]);

  const fetchPipelines = async () => {
    try {
      const res = await GetRequest(
        `lead/fetchPipelines/${customerId}/leads/${loginUserId}/${userType}`,
        { headers },
        extras
      );
      if (res?.status === "fail" || res?.success === false) {
        setSelectedPipelineId(null);
        setPipelines(null);
        return;
      }
      setPipelines(res.data);
      if (res?.data?.length) {
        const activePipe =
          res.data.find((el) => el.is_active === "yes") || res.data[0];
        setSelectedPipelineId(activePipe.id);
      }
    } catch {
      setSelectedPipelineId(null);
      setPipelines(null);
    }
  };

  const fetchPipelineStage = async () => {
    try {
      const res = await GetRequest(
        `lead/fetchPipelineStage/${selectedPipelineId}/${customerId}/${loginUserId}`,
        { headers },
        extras
      );
      if (res?.status === "fail" || res?.success === false) {
        setPipelineStages(null);
        return;
      }
      setPipelineStages(
        res.data?.map((c) => ({
          value: c.id,
          label: c.stage_name,
        }))
      );
    } catch {
      setPipelineStages(null);
    }
  };

  useEffect(() => {
    if (selectedTab !== "leads") return;
    fetchPipelines();
  }, [selectedTab]);

  useEffect(() => {
    if (selectedTab !== "leads" || !selectedPipelineId) return;
    fetchPipelineStage();
  }, [selectedTab, selectedPipelineId]);


  //  allFstate for filter hydration
  const fetchAllStatesData = async () => {
    try {
      const data = await getAllStates()
      if (!data || data === undefined) {
        setAllState([])
        return
      }
      setAllState(
        data.map((state) => ({
          label: state.state_name,
          value: state.id,
        }))
      )
    } catch (error) {
      toast.error("Error Fetching State")
      return
    }
  }

  // allcity useeffect for filter hydration
  const fetchAllCitiesData = async () => {
    try {
      const data = await getAllCities()
      if (!data || data === undefined) {
        setAllCity([])
        return
      }
      setAllCity(
        data.map((city) => ({
          label: city.city_name,
          value: city.id,
        }))
      )
    } catch (error) {
      toast.error("Error Fetching State")
      return
    }
  }

  // useeffect for country
  const fetchCountriesData = async () => {
    try {
      const data = await getCountries()
      if (!data) return
      setCountries(
        data.map((country) => ({
          label: country.name,
          value: country.id,
        }))
      )
    } catch (error) {
      toast.error("Error Fetching Data")
      return
    }
  }

  // running all requests parallely
  const initData = async () => {
    await Promise.all([
      fetchCountriesData(),
      fetchAllStatesData(),
      fetchAllCitiesData(),
    ])
  }
  useEffect(() => {
    initData()
  }, [])


  useEffect(() => {
    if (selectedTab !== 'leads') return
    fetchPipelines()
    fetchPipelineStage()
  }, [selectedTab, selectedPipelineId])
  //fetch tab list data
  const handleListData = async (id) => {
    if (currAdvFilter === "apply") return;
    let endpoint = "";
    if (selectedTab === "leads") {
      if (!selectedPipelineId) return;
      endpoint = `lead/fetchLeads/${customerId}/${selectedPipelineId}/${loginUserId}/${userType}/list/${id}`;
    } else if (selectedTab === "contact") {
      endpoint = `contacts/fetchAllContacts/${loginUserId}/${customerId}/${userType}/${id}`;
    } else if (selectedTab === "company") {
      endpoint = `company/fetchAllCompanies/${customerId}/${loginUserId}/${id}`;
    }

    if (!endpoint) return;

    try {
      setListLoading(true);
      const res = await GetRequest(
        endpoint,
        { headers, params: { limit: listLimit, offset: listOffset, search: "" } },
        extras
      );
      if (res?.status === "fail" || res?.success === false) {
        setListTableData([]);
        setListTotalCount(0);
        return;
      }
      setListTableData(res?.data || []);
      setListTotalCount(res?.total_count ?? res?.data?.length ?? 0);
      const filterValuesRaw = res?.filter_data?.[0]?.filter_values;
      if (filterValuesRaw) {
        try {
          const parsed =
            typeof filterValuesRaw === "string"
              ? JSON.parse(filterValuesRaw)
              : filterValuesRaw;
          setParsedFilterData(parsed);
        } catch {
          setParsedFilterData(null);
        }
      }
    } catch (error) {
      console.error(error);
      toast.error("Failed to load segment records");
    } finally {
      setListLoading(false);
    }
  };

  const handleFilterCardPageChange = (newOffset) => {
    setFilterCardOffset(newOffset.selected);
  };

  const handleListPageChange = (newOffset) => {
    setListOffset(newOffset.selected);
  };

  // parsed data — options already { value, label } from useCommonData / location
  useEffect(() => {
    if (!parsedFilterData || !Array.isArray(parsedFilterData) || dropdownOptions.length === 0) {
      return;
    }
    const filteredArray = parsedFilterData.map((state) => {
      const dropdownOption = dropdownOptions.find(
        (opt) => opt.value === state.label_name
      );
      return {
        id: state.label_name,
        field: state.label_name,
        label_name: dropdownOption ? dropdownOption.label : state.label_name,
        option: dropdownOption?.option ?? null,
        subFilterType: state.label_query,
        value: state.label_value,
      };
    });
    setFilterState(filteredArray);
  }, [parsedFilterData, dropdownOptions]);

  const fetchTabData = async () => {
    const endpoint = getFilterCardsEndpoint(selectedTab);
    if (!endpoint || !customerId || !loginUserId) return;
    if (selectedTab === "leads" && !selectedPipelineId) return;

    try {
      setLoading(true);
      const res = await GetRequest(endpoint, { headers }, extras);
      if (res?.success === false) {
        setTabData([]);
        setActiveCardId(null);
        setFilterPageCount(0);
        toast.error(res.message);
        return;
      }
      if (res?.status === "fail") {
        setTabData([]);
        setActiveCardId(null);
        setFilterPageCount(0);
        return;
      }
      const cards = res?.data || [];
      setTabData(cards);
      if (res.total_count) {
        setFilterPageCount(Math.ceil(res.total_count / FILTER_CARD_LIMIT));
      } else {
        setFilterPageCount(
          cards.length >= FILTER_CARD_LIMIT ? filterCardOffset + 2 : filterCardOffset + 1
        );
      }
      if (cards.length > 0) {
        const stillActive = cards.some((c) => c.id === activeCardId);
        if (!stillActive) {
          setActiveCardId(cards[0].id);
          setListOffset(0);
        }
      } else {
        setActiveCardId(null);
        setListTableData([]);
        setListTotalCount(0);
        setParsedFilterData(null);
        setFilterState([]);
      }
    } catch (err) {
      console.error("Tab fetch error", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTabData();
  }, [selectedTab, refetchTabData, filterCardOffset, selectedPipelineId]);

  useEffect(() => {
    if (currAdvFilter === "apply") return;
    if (!activeCardId) return;
    if (selectedTab === "leads" && !selectedPipelineId) return;
    handleListData(activeCardId);
  }, [activeCardId, listOffset, listLimit, selectedPipelineId, currAdvFilter]);

  // edit list name
  const editCampaignName = async () => {
    if (!campaignName?.trim() || !updateCampaignId) return;
    const payload = {
      customer_id: customerId,
      user_login_id: loginUserId,
      filter_id: updateCampaignId,
      card_name: campaignName.trim(),
      description: description || "",
      module_name: getFilterRenameModuleName(selectedTab),
    };
    try {
      const res = await PutRequest("common/updateFilterName", payload, { headers }, extras);
      if (res?.status === "fail" || res?.success === false) {
        toast.error(res?.message || "Error updating filter");
        return;
      }
      toast.success(res?.message || "Campaign target parameter modified");
      await fetchTabData();
      setShowModal(false);
    } catch (error) {
      console.error(error);
      toast.error("Error updating filter");
    }
  };

  const deleteItemById = async () => {
    if (!deleteItemId) return;
    const deleteEndpoint = getDeleteFilterEndpoint(selectedTab, deleteItemId);
    if (!deleteEndpoint) return;
    setIsLoading(true);
    try {
      const res = await DeleteRequest(deleteEndpoint, { headers }, extras);
      if (res?.status === "fail" || res?.success === false) {
        toast.error(res?.message || "Failed to delete segment");
        return;
      }
      toast.success(res?.message || "Target list purged successfully");
      setRefetchTabData((prev) => !prev);
    } catch (err) {
      toast.error("Failed to delete segment");
    } finally {
      setShowDeleteModal(false);
      setDeleteItemId(null);
      setFilterDropdown(false);
      setTempFilterData(null);
      setIsLoading(false)
      setFilterState([]); // Clear filter states
      setParsedFilterData(null); // Clear parsed data
    }
  };

  if (!whatsappCampaignGrant?.isView) {
    return (
      <div className="container-fluid py-4 bg-light min-vh-100">
        <AuthorizationCard />
      </div>
    );
  }

  return (
    <div className="container-fluid py-4 px-lg-5 bg-slate-50 min-vh-100" style={{ backgroundColor: "#f8fafc" }}>
      <div className="row g-4">
        <div className="col-12">
          <div className="d-flex align-items-center justify-content-between bg-white p-4 rounded-4 shadow-2xs border border-slate-100">
            <div className="d-flex align-items-center gap-3">
              <div className="p-3 rounded-3 d-flex align-items-center justify-content-center bg-success-subtle" style={{ width: "50px", height: "50px" }}>
                <i className="fab fa-whatsapp text-success fs-4" />
              </div>
              <div>
                <h4 className="mb-1 text-dark fw-bold">WhatsApp Campaigns</h4>
                <p className="mb-0 text-muted small">Configure target segments and dispatch WhatsApp broadcast sequences.</p>
              </div>
            </div>
          </div>
        </div>

        <div className="col-xl-7 d-flex flex-column gap-2 mt-2">
          <div className="card shadow-2xs border border-slate-100 p-4 bg-white rounded-4">
            <div className="d-flex align-items-center justify-content-between pb-3 border-bottom border-slate-100 mb-3">
              <div className="d-flex align-items-center gap-2">
                <FontAwesomeIcon icon={faLayerGroup} className="text-primary" />
                <span className="fw-bold text-dark">Target Segment Engine</span>
              </div>
              <div className="bg-slate-100 p-1 rounded-3 d-flex gap-1" style={{ backgroundColor: "#f1f5f9" }}>
                {["leads", "company", "contact"].map((tab) => (
                  <button
                    key={tab}
                    type="button"
                    className={`btn btn-sm px-3 py-1 text-capitalize fw-semibold rounded-2 transition-all border-0 ${selectedTab === tab ? "bg-white text-primary shadow-2xs" : "text-secondary bg-transparent"}`}
                    onClick={() => {
                      setFilterDropdown(false);
                      setSelectedTab(tab);
                      setFilterState([]);
                      setParsedFilterData(null);
                      setListTableData([]);
                      setActiveCardId(null);
                      setFilterCardOffset(0);
                      setListOffset(0);
                      setCurrAdvFilter(null);
                      setTempFilterData(null);
                    }}
                  >
                    {tab}
                  </button>
                ))}
              </div>
            </div>

            <div className="d-flex align-items-center justify-content-end flex-wrap gap-3 mb-3">
              <div style={{ minWidth: "200px" }}>
                {selectedTab === "leads" && pipeline && (
                  <Select
                    options={pipelineOptions}
                    value={pipelineOptions?.find((option) => option.value === selectedPipelineId)}
                    onChange={(selectedOption) => {
                      setSelectedPipelineId(selectedOption.value);
                      setListOffset(0);
                      setFilterCardOffset(0);
                      setActiveCardId(null);
                      setCurrAdvFilter(null);
                      setTempFilterData(null);
                    }}
                    styles={{
                      ...customStyles,
                      control: (base) => ({
                        ...base,
                        height: "38px",
                        borderRadius: "10px",
                        borderColor: "#e2e8f0",
                        boxShadow: "none",
                        backgroundColor: "#f8fafc",
                        "&:hover": { borderColor: "#cbd5e1" },
                      }),
                      singleValue: (base) => ({
                        ...base,
                        fontSize: "0.85rem",
                        fontWeight: 600,
                        color: "#334155",
                        marginLeft: "10px",
                      }),
                      option: (base) => ({ ...base, fontSize: "0.85rem" }),
                    }}
                    isSearchable
                    placeholder="Filter by Pipeline..."
                  />
                )}
              </div>
              <Filter
                canEdit_canDownload={true}
                filterDropdown={filterDropdown}
                setFilterDropdown={setFilterDropdown}
                dropdownOptions={dropdownOptions}
                filterState={filterStates}
                setFilterState={setFilterState}
                subFilter={subFilter}
                customSubFilter={customSubFilter}
                module_name={currModule}
                setTempFilterData={setTempFilterData}
                setCurrAdvFilter={setCurrAdvFilter}
                filterEndpoint={currFilterEndpoint}
                applyQuery={currFilterApplyQuery}
                filterQueryKey={WHATSAPP_CAMPAIGN_FILTER_QUERY_KEY}
                view="list"
                pipelineId={selectedPipelineId}
                setOffset={setListOffset}
                setHeading={() => setRefetchTabData((prev) => !prev)}
              />
            </div>

            {loading ? (
              <div className="text-center py-4 text-secondary small">
                <div className="spinner-border spinner-border-sm me-2 text-primary" /> Loading Segment Tokens...
              </div>
            ) : tabData?.length > 0 ? (
              <div className="d-flex flex-column gap-3">
                <div className="d-flex gap-2 align-items-center flex-wrap custom-horizontal-scrollbar py-1">
                  {tabData.map((item) => (
                    <div
                      key={item.id}
                      onClick={() => {
                        setCurrAdvFilter(null);
                        setTempFilterData(null);
                        setListOffset(0);
                        setActiveCardId(item.id);
                      }}
                      className="d-flex align-items-center justify-content-between p-2.5 border rounded-3 transition-all"
                      style={{
                        minWidth: "190px",
                        maxWidth: "230px",
                        cursor: "pointer",
                        backgroundColor: activeCardId === item.id ? "#eff6ff" : "#ffffff",
                        borderColor: activeCardId === item.id ? "#3b82f6" : "#e2e8f0",
                      }}
                    >
                      <span className={`text-truncate fw-semibold px-1 small ${activeCardId === item.id ? "text-primary" : "text-dark"}`}>
                        {item.card_name}
                      </span>
                      <Dropdown onClick={(e) => e.stopPropagation()} align="end">
                        <Dropdown.Toggle as="button" className="btn btn-link p-1 text-muted no-arrow shadow-none border-0">
                          <FontAwesomeIcon icon={faEllipsisVertical} size="sm" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="shadow-sm border-0 py-1" style={{ fontSize: "13px" }}>
                          <Dropdown.Item
                            onClick={() => {
                              setCurrAdvFilter(null);
                              setTempFilterData(null);
                              setListOffset(0);
                              setActiveCardId(item.id);
                            }}
                          >
                            <FontAwesomeIcon icon={faEye} className="me-2 text-muted" /> View Group
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => {
                              if (!whatsappCampaignGrant?.isEdit) {
                                toast.warning("You are not authorized for this action!");
                                return;
                              }
                              setCampaignName(item.card_name);
                              setUpdateCampaignId(item.id);
                              setDescription(item.description);
                              setShowModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faEdit} className="me-2 text-muted" /> Edit Label
                          </Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item
                            className="text-danger"
                            onClick={() => {
                              if (!whatsappCampaignGrant?.isDelete) {
                                toast.warning("You are not authorized for this action!");
                                return;
                              }
                              setDeleteItemId(item.id);
                              setShowDeleteModal(true);
                            }}
                          >
                            <FontAwesomeIcon icon={faTrash} className="me-2" /> Delete Segment
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                  ))}
                </div>
                {filterPageCount > 1 && (
                  <Pagination
                    offset={filterCardOffset}
                    setOffset={setFilterCardOffset}
                    handlePageChange={handleFilterCardPageChange}
                    pageCount={filterPageCount}
                  />
                )}
              </div>
            ) : (
              <div className="text-center py-4 text-muted border border-dashed rounded-3 small bg-slate-50">
                No targeted query modules verified. Configure filter parameters to establish tracking segments.
              </div>
            )}
          </div>

          <div className="card shadow-2xs border border-slate-100 p-4 bg-white rounded-4 flex-grow-1">
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3 pb-2 border-bottom border-slate-100">
              <span className="fw-bold text-dark">Segment Population Matrix</span>
              <div className="d-flex align-items-center gap-2">
                <span className="text-muted small">Rows per page</span>
                <Dropdown align="end">
                  <Dropdown.Toggle
                    className="btn btn-outline-light text-dark border border-slate-200 no-arrow btn-sm px-2.5 py-1 rounded-2 shadow-2xs bg-white"
                    style={{ display: "flex", alignItems: "center", gap: "6px" }}
                  >
                    {listLimit}
                    <i className="bx bx-chevron-down text-slate-500" style={{ fontSize: "16px" }} />
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end" className="shadow-sm border-0 mt-1" style={{ minWidth: "3rem", textAlign: "center", zIndex: 1050 }}>
                    {LIST_LIMIT_OPTIONS.map((el) => (
                      <Dropdown.Item
                        key={el}
                        onClick={() => {
                          setListLimit(el);
                          setListOffset(0);
                        }}
                      >
                        {el}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>

            {(listLoading || tempFilterDataLoading) && (
              <div className="text-center py-3 text-secondary small">
                <div className="spinner-border spinner-border-sm me-2 text-primary" /> Loading records...
              </div>
            )}

            <div className="table-responsive border border-slate-100 rounded-3 position-relative" style={{ maxHeight: "380px" }}>
              <Table hover striped size="sm" className="mb-0 align-middle text-nowrap" style={{ fontSize: "13px" }}>
                <thead className="bg-slate-50 text-slate-600 border-bottom border-slate-100" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                  <tr>
                    <th className="py-2.5 px-3 fw-semibold">#</th>
                    <th className="fw-semibold">Name</th>
                    <th className="fw-semibold">Email</th>
                    <th className="fw-semibold">Phone Number</th>
                    {selectedTab === "contact" && (
                      <>
                        <th className="fw-semibold">Lead Source</th>
                        <th className="fw-semibold">Lead Owner</th>
                      </>
                    )}
                    {selectedTab === "company" && <th className="fw-semibold">Rating System</th>}
                    {selectedTab === "leads" && (
                      <>
                        <th className="fw-semibold">Status Flag</th>
                        <th className="fw-semibold">Lead Owner</th>
                      </>
                    )}
                  </tr>
                </thead>
                <tbody className="text-slate-600 border-0">
                  {dataToDisplay?.length > 0 ? (
                    dataToDisplay.map((item, i) => {
                      let phoneNumber = item.phone;
                      if (selectedTab === "leads" && item.contact_phone) {
                        try {
                          const parsed = typeof item.contact_phone === "string" ? JSON.parse(item.contact_phone) : item.contact_phone;
                          phoneNumber = parsed?.[0]?.phone ?? "—";
                        } catch {
                          phoneNumber = "—";
                        }
                      }
                      return (
                        <tr key={item.id || i}>
                          <td className="py-2.5 px-3 fw-medium text-dark">{listOffset + i + 1}</td>
                          <td className="fw-semibold text-slate-900" style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", maxWidth: "150px" }}>
                            {item.first_name || item.company_name || "N/A"}
                          </td>
                          <td>{selectedTab === "leads" ? item.contact_email : item.email || "—"}</td>
                          <td>{phoneNumber || "—"}</td>
                          {selectedTab === "contact" && (
                            <>
                              <td><span className="badge border" style={{ background: "#f1f5f9", color: "#065f46" }}>{item.source_title || "Organic"}</span></td>
                              <td>{item.owner_name || "—"}</td>
                            </>
                          )}
                          {selectedTab === "company" && (
                            <td className="fw-bold text-amber-500">★ {item.rating || "0.0"}</td>
                          )}
                          {selectedTab === "leads" && (
                            <>
                              <td>
                                <span
                                  className="badge px-2 py-1"
                                  style={{
                                    backgroundColor: item.lead_status?.toLowerCase() === "unqualified" ? "#f1f5f9" : "#d1e8ff",
                                    color: item.lead_status?.toLowerCase() === "unqualified" ? "#065f46" : "#0984e3",
                                  }}
                                >
                                  {item.lead_status || item.status || "Unassigned"}
                                </span>
                              </td>
                              <td>{item.lead_owner_name || item.owner_name || "—"}</td>
                            </>
                          )}
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td className="text-center py-4 text-muted small" colSpan={100}>
                        No production records matched against the target search profile matrix.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 pt-3 mt-2 border-top border-slate-100">
              <span className="text-muted small fw-medium">
                Showing <strong className="text-dark">{startItemIndex}-{endItemIndex}</strong> of <strong className="text-dark">{activeListTotalCount}</strong> items
              </span>
              {activeListTotalCount > listLimit && (
                <Pagination
                  offset={listOffset}
                  setOffset={setListOffset}
                  handlePageChange={handleListPageChange}
                  pageCount={listPageCount}
                />
              )}
            </div>
          </div>
        </div>

        <div className="col-xl-5">
          <div className="card shadow-2xs border border-slate-100 p-4 bg-white rounded-4 sticky-top" style={{ top: "24px", zIndex: 9 }}>
            <div className="d-flex align-items-center gap-2 pb-3 border-bottom border-slate-100 mb-4">
              <i className="fab fa-whatsapp text-success fs-5" />
              <span className="fw-bold text-dark fs-6">WhatsApp Message Composer</span>
            </div>
            <WhatsappModal
              currentTab={selectedTab}
              filterQueryValue={filterQueryValue}
              setFilterQueryValue={setFilterQueryValue}
              filterQueryValues={filterQueryValues}
              setfilterQueryValues={setFilterQueryValues}
            />
          </div>
        </div>
      </div>

      {/* Delete Modal */}
      {showDeleteModal && (
        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={deleteItemById}
          isLoading={isLoading}
          message="Are you certain you want to permanently strip out this selection target parameter rule set?"
        />
      )}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered className="border-0">
        <Modal.Header closeButton className="pb-2 border-0">
          <Modal.Title className="fw-bold text-dark fs-6">Modify Parameter Label</Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-2">
          <Form.Group>
            <Form.Label className="text-muted small mb-1">Target Segment Title Name <span className="text-danger">*</span></Form.Label>
            <Form.Control
              type="text"
              size="sm"
              placeholder="Input updated label tag"
              value={campaignName}
              onChange={(e) => setCampaignName(e.target.value)}
              className="rounded-3 shadow-none border-slate-200 py-2"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="pt-2 border-0">
          <Button variant="light" className="fw-semibold px-3 border rounded-3" onClick={() => setShowModal(false)}>
            Dismiss
          </Button>
          <Button variant="primary" className="fw-bold px-4 rounded-3" onClick={editCampaignName}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <style>{`
        .custom-horizontal-scrollbar::-webkit-scrollbar { height: 4px; }
        .custom-horizontal-scrollbar::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 4px; }
        .no-arrow::after { display: none !important; }
        .table-responsive::-webkit-scrollbar { width: 4px; height: 4px; }
        .table-responsive::-webkit-scrollbar-thumb { background-color: #cbd5e1; border-radius: 4px; }
      `}</style>
    </div>
  );
};
